import http from "@/utils/http";

export interface IAliyunRequest {
  filename: string;
  floderId?: number;
  projectId: number;
  size: number;
}

export interface IAliOssToken {
  accessid: string;
  callback: string;
  dir: string;
  expire: string;
  host: string;
  policy: string;
  signature: string;
}

export const getUploadToken = async (
  data: IAliyunRequest,
  method = "media",
): Promise<IAliOssToken> => {
  try {
    const result = await http.post(`/api/v1/space/oss/upload`, {
      name: data.filename,
      folder_id: data.floderId,
      project_id: data.projectId,
      method: method,
      size: data.size,
      source: 1,
    });
    return result.data;
  } catch (error) {
    console.error("Error fetching upload token:", error);
    throw error;
  }
};

export const fileUploadToken = async (
  data,
  method = "file",
): Promise<IAliOssToken> => {
  try {
    const result = await http.post(`/api/v1/space/oss/upload`, {
      name: data.filename,
      method: method,
      size: data.size,
      source: 1,
    });
    return result.data;
  } catch (error) {
    console.error("Error fetching upload token:", error);
    throw error;
  }
};
export async function getImageUrl(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/space/oss/url?oss_key=${params}`)
    if (res) {
      return res
    } else {
      console.log('接口错误')
    }
  } catch (err) {
    console.log(err)
    return err
  }
}
